import { PulseBaseProvider } from '../../base-classes';
import { unitSystems } from '../../utilities/units';

const _dailyForecastUri = '/api/for/daily/v5';
const _dailyForecastCacheKey = 'dailyForecast';

export class ForecastProviderV5 extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_dailyForecastCacheKey] = this.dailyForecastSyncer.bind(this);
    }

    async dailyForecastSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            offset: syncParams.offset,
            verbose: syncParams.verbose,
            temperatureUnit: syncParams.specificUnits.temperatureUnit,
            pressureUnit: syncParams.specificUnits.pressureUnit,
            directionUnit: syncParams.specificUnits.directionUnit,
            distanceUnit: syncParams.specificUnits.distanceUnit,
            speedUnit: syncParams.specificUnits.speedUnit,
            precipitationUnit: syncParams.specificUnits.precipitationUnit,
            precipitationRateUnit: syncParams.specificUnits.precipitationRateUnit,
            roundingProfile: syncParams.roundingProfile
        };

        const responseValidator = response => {
            return !!response;
        };

        const apiPath = `${_dailyForecastUri}/locationType=${syncParams.locationtype}/location=${syncParams.location}`;

        return await super.syncData(syncParams.key, id, queryParams, apiPath, resolve, reject, responseValidator, syncParams.pulseApi, null, null, true);
    }

    async getDailyForecastV5(location, locationtype, offset, stdParameters, verbose = false, refresh = false, roundingProfile = 'displayV1', specificUnits) {
        const syncParams = {
            location,
            locationtype,
            offset: offset && offset >= 0 ? offset : 0,
            verbose: !!verbose,
            refresh,
            stdParameters,
            roundingProfile,
            specificUnits,
            cultureinfo: stdParameters?.cultureinfo
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_dailyForecastCacheKey, id);
        }
        return await super.loadFromStorage(_dailyForecastCacheKey, id, syncParams);
    }
}
